<template>
  <!--Add Page Container-->
  <div>
    <div class="page">
      <div class="float-left">
        <h2>Page 1</h2>
        <label>
          <b>0 Apps</b>
        </label>
      </div>
      <i class="fa fa-ellipsis-v float-right"></i>
      <div class="actions-menu">
        <button type="button" class="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="clearfix"></div>
        <button>
          <i class="fa fa-edit"></i> Rename
        </button>
        <button>
          <i class="fa fa-trash"></i> Delete
        </button>
        <button>
          <i class="fa fa-eye"></i> add action
        </button>
      </div>
      <div class="clearfix"></div>
      <div class="add-app">
        <div class="drag-app">
          <label>Drag Here</label>
        </div>
      </div>
    </div>
    <div>
      <div class="page">
        <div class="float-left">
          <h2>Page 1</h2>
          <label>
            <b>7 Apps</b>
          </label>
        </div>
        <i class="fa fa-ellipsis-v float-right"></i>
        <div class="actions-menu">
          <button type="button" class="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="clearfix"></div>
          <button>
            <i class="fa fa-edit"></i> Rename
          </button>
          <button>
            <i class="fa fa-trash"></i> Delete
          </button>
          <button>
            <i class="fa fa-eye"></i> add action
          </button>
        </div>
        <div class="clearfix"></div>
        <div class="row">
          <div class="col-sm-3 float-left">
            <div class="app">
              <img src="../../assets/images/sentio-logo.png">
            </div>
          </div>
          <div class="col-sm-3 float-left">
            <div class="app">
              <img src="../../assets/images/PO-logo.png">
            </div>
          </div>
          <div class="col-sm-3 float-left">
            <div class="app">
              <img src="../../assets/images/PO-logo.png">
            </div>
          </div>
          <div class="col-sm-3 float-left">
            <div class="app">
              <img src="../../assets/images/PO-logo.png">
            </div>
          </div>
          <div class="col-sm-3 float-left">
            <div class="app">
              <img src="../../assets/images/PO-logo.png">
            </div>
          </div>
          <div class="col-sm-3 float-left">
            <div class="app">
              <img src="../../assets/images/PO-logo.png">
            </div>
          </div>
          <div class="col-sm-3 float-left">
            <div class="app">
              <img src="../../assets/images/PO-logo.png">
            </div>
          </div>
          <div class="col-sm-3 float-left">
            <div class="app">
              <img src="../../assets/images/PO-logo.png">
            </div>
          </div>
          <div class="col-sm-3 float-left">
            <div class="app">
              <img src="../../assets/images/PO-logo.png">
            </div>
          </div>
          <div class="col-sm-3 float-left">
            <div class="app">
              <img src="../../assets/images/PO-logo.png">
            </div>
          </div>
          <div class="col-sm-3 float-left">
            <div class="app">
              <img src="../../assets/images/PO-logo.png">
            </div>
          </div>
        </div>
      </div>
      <button class="add-page-btn float-right">
        <i class="fa fa-plus"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageComponent"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page.apps-slider-opened{
    height: calc(100vh - 20rem); /* fallback if css var is not supported*/
    height: calc(calc(var(--vh, 1vh) * 100) - 20rem);
}
.page {
  background: rgba(0,111,143,.7);
  width: 60%;
  position: absolute;
  left: 50%;
  top: 6rem;
  transform: translateX(-50%);
  padding: 1rem 2rem;
  height: calc(100vh - 10rem); /* fallback if css var is not supported*/
  height: calc(calc(var(--vh, 1vh) * 100) - 10rem);
  overflow-y: auto;
  overflow-x: hidden;
  transition:all .5s
}
.page h1 {
  margin-top: 0;
}
.page .fa-ellipsis-v {
  font-size: 1.8rem;
  margin-top: 1rem;
}
.page + button.add-page-btn {
  position: absolute;
  right: 6%;
  bottom: 40%;
}
.page .add-app {
  background: rgba(68, 177, 203, 0.5);
  width: 100%;
  height: calc(100vh - 16rem); /* fallback if css var is not supported*/
  height: calc(calc(var(--vh, 1vh) * 100) - 16rem);
  padding: 0.5rem;
}
.page .add-app .drag-app {
  border: dashed 1px rgba(255, 255, 255, 0.8);
  height: 100%;
  position: relative;
}
.page .add-app .drag-app label {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 1rem;
}
.actions-menu {
  height: 100%;
  position: absolute;
  right: -30%;
  background: #fff;
  width: 30%;
  top: 0;
  transition: all 0.3s ease;
  z-index: 99;
}
.actions-menu.opened {
  right: 0;
  box-shadow: -10px 0px 10px 1px rgba(0, 0, 0, 0.3);
}
.actions-menu .close {
  margin-right: 10px;
  font-size: 3rem;
}
.actions-menu button {
  background: transparent;
  border: 0;
  color: #39464e;
  text-transform: uppercase;
  padding-left: 2rem;
  font-size: 1rem;
  font-weight: bold;
  padding-bottom: 2.3rem;
  display: block;
}
.actions-menu button i {
  margin-right: 0.5rem;
  font-size: 1.2rem;
}
.actions-menu button:focus {
  outline: none;
}
</style>
